import { render } from "./card-deposit.vue?vue&type=template&id=b77f06ea&scoped=true&ts=true"
import script from "./card-deposit.vue?vue&type=script&lang=ts"
export * from "./card-deposit.vue?vue&type=script&lang=ts"

import "./card-deposit.vue?vue&type=style&index=0&id=b77f06ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77f06ea"]])

export default __exports__